import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

export enum PropertyValuation {
  ONE_STAR = 1,
  TWO_STAR = 2,
  THREE_STAR = 3,
  FOUR_STAR = 4,
  FIVE_STAR = 5,
}

export enum PropertyType {
  INVALID_PROPERTY_TYPE = "INVALID_PROPERTY_TYPE",
  HOTEL = "HOTEL",
  APART_HOTEL = "APART_HOTEL",
  APARTMENT = "APARTMENT",
  HOSTEL = "HOSTEL",
  HOUSES = "HOUSES",
  HOTEL_WITH_SPA = "HOTEL_WITH_SPA",
  RURAL = "RURAL",
  WATERING_PLACE = "WATERING_PLACE",
  WELLNESS = "WELLNESS",
  PARKING = "PARKING",
  EXCURSIONS = "EXCURSIONS",
}

export const propertyMessages = defineMessages({
  entityName: {
    id: "property.entityName",
    defaultMessage: "Property info",
  },
  active: {
    id: "app.active",
    defaultMessage: "active",
  },
  location: {
    id: "app.location",
    defaultMessage: "location",
  },
  country: {
    id: "app.country",
    defaultMessage: "country",
  },
  city: {
    id: "app.city",
    defaultMessage: "city",
  },
  address: {
    id: "app.address",
    defaultMessage: "address",
  },
  zipCode: {
    id: "app.zipCode",
    defaultMessage: "zipCode",
  },
  searchCoordinates: {
    id: "app.searchCoordinates",
    defaultMessage: "Search coordinates",
  },
  searchCoordinatesHelpText: {
    id: "app.searchCoordinatesHelpText",
    defaultMessage:
      "If you don't know the exact coordinates, search for a street address or place name to find them.",
  },
  latitude: {
    id: "app.latitude",
    defaultMessage: "latitude",
  },
  longitude: {
    id: "app.longitude",
    defaultMessage: "longitude",
  },
  timeZone: {
    id: "app.timeZone",
    defaultMessage: "Time zone",
  },
  contact: {
    id: "app.contact",
    defaultMessage: "contact",
  },
  images: {
    id: "app.images",
    defaultMessage: "images",
  },
  imagesHelpText: {
    id: "app.imagesHelpText",
    defaultMessage:
      "Las imágenes deben tener una resolución 1900 x 1080 pixeles y un tamaño máximo de 10MB",
  },
  type: {
    id: "app.type",
    defaultMessage: "type",
  },
  phone: {
    id: "app.phone",
    defaultMessage: "phone",
  },
  adminEmail: {
    id: "property.adminEmail",
    defaultMessage: "adminEmail",
  },
  contactEmail: {
    id: "property.contactEmail",
    defaultMessage: "type",
  },
  valuation: {
    id: "property.valuation",
    defaultMessage: "valuation",
  },
  propertyTranslationsTitle: {
    id: "app.translations",
    defaultMessage: "translations",
  },
  propertyTranslationsDescriptionLabel: {
    id: "property.translations.description",
    defaultMessage: "Description",
  },
  propertyTranslationsNameLabel: {
    id: "property.translations.name",
    defaultMessage: "Name",
  },
  invalidCoordinate: {
    id: "property.errors.invalidCoordinate",
    defaultMessage: "invalidCoordinate",
  },
  amenities: {
    id: "property.amenities",
    defaultMessage: "Property Amenities",
  },
  amenitiesSection: {
    id: "property.amenitiesSection",
    defaultMessage: "Amenities",
  },
  amenitiesDeleteAll: {
    id: "property.amenities.deleteAll",
    defaultMessage: "Clear all",
  },
  amenitiesPlaceholder: {
    id: "property.amenities.placeholder",
    defaultMessage: "Select amenities",
  },
  amenitiesNoOptions: {
    id: "property.amenities.noOptions",
    defaultMessage: "No amenities found",
  },
});

export const propertyValuationMessages = defineMessages({
  [PropertyValuation.ONE_STAR]: {
    id: "shared.propertyValuation.ONE_STAR",
    description: "ONE_STAR",
    defaultMessage: "ONE_STAR",
  },
  [PropertyValuation.TWO_STAR]: {
    id: "shared.propertyValuation.TWO_STAR",
    description: "TWO_STAR",
    defaultMessage: "TWO_STAR",
  },
  [PropertyValuation.THREE_STAR]: {
    id: "shared.propertyValuation.THREE_STAR",
    description: "THREE_STAR",
    defaultMessage: "THREE_STAR",
  },
  [PropertyValuation.FOUR_STAR]: {
    id: "shared.propertyValuation.FOUR_STAR",
    description: "FOUR_STAR",
    defaultMessage: "FOUR_STAR",
  },
  [PropertyValuation.FIVE_STAR]: {
    id: "shared.propertyValuation.FIVE_STAR",
    description: "FIVE_STAR",
    defaultMessage: "FIVE_STAR",
  },
});

export const propertyTypeMessages = defineMessages({
  [PropertyType.HOTEL]: {
    id: "shared.propertyType.HOTEL",
    description: "HOTEL",
    defaultMessage: "HOTEL",
  },
  [PropertyType.APART_HOTEL]: {
    id: "shared.propertyType.APART_HOTEL",
    description: "APART_HOTEL",
    defaultMessage: "APART_HOTEL",
  },
  [PropertyType.APARTMENT]: {
    id: "shared.propertyType.APARTMENT",
    description: "APARTMENT",
    defaultMessage: "APARTMENT",
  },
  [PropertyType.HOSTEL]: {
    id: "shared.propertyType.HOSTEL",
    description: "HOSTEL",
    defaultMessage: "HOSTEL",
  },
  [PropertyType.HOUSES]: {
    id: "shared.propertyType.HOUSES",
    description: "HOUSES",
    defaultMessage: "HOUSES",
  },
  [PropertyType.HOTEL_WITH_SPA]: {
    id: "shared.propertyType.HOTEL_WITH_SPA",
    description: "HOTEL_WITH_SPA",
    defaultMessage: "HOTEL_WITH_SPA",
  },
  [PropertyType.RURAL]: {
    id: "shared.propertyType.RURAL",
    description: "RURAL",
    defaultMessage: "RURAL",
  },
  [PropertyType.WATERING_PLACE]: {
    id: "shared.propertyType.WATERING_PLACE",
    description: "WATERING_PLACE",
    defaultMessage: "WATERING_PLACE",
  },
  [PropertyType.WELLNESS]: {
    id: "shared.propertyType.WELLNESS",
    description: "WELLNESS",
    defaultMessage: "WELLNESS",
  },
  [PropertyType.PARKING]: {
    id: "shared.propertyType.PARKING",
    description: "PARKING",
    defaultMessage: "PARKING",
  },
  [PropertyType.EXCURSIONS]: {
    id: "shared.propertyType.EXCURSIONS",
    description: "EXCURSIONS",
    defaultMessage: "EXCURSIONS",
  },
});

export const messages = {
  ...defaultCrudMessages,
  ...propertyMessages,
  ...propertyTypeMessages,
  ...propertyValuationMessages,
};
